export const VENDOR_PINNED_LEFT_COLUMN_VALUES = ['name'];

export const VENDOR_SELECTION_COLUMN_WIDTH = 60;
export const VENDOR_NAME_COLUMN_WIDTH = 200;

/** Columns with reliable scalar / date DB values for server-side orderBy. */
export const VENDOR_SORTABLE_COLUMN_VALUES = [
  'name',
  'status',
  'expirationDate',
  'cageCode',
  'ueiCode',
  'bussinessStartDate',
  'setAsides',
  'sbaDetails',
  'state',
  'naics',
  'psc',
  'tags',
];

export const DEFAULT_VENDOR_ORDER = ['alphabetical', 'asc'];

export const getVendorColumnWidth = () => VENDOR_NAME_COLUMN_WIDTH;

export const getVisibleVendorColumns = (tableColumns = []) =>
  (Array.isArray(tableColumns) ? tableColumns : []).filter((column) => column?.active);

export const getVendorRowKey = (item) => {
  if (!item) return 'vendor-row';
  return item.id ?? item.vendorId ?? item.documentId ?? item.ueiCode ?? item.name ?? 'vendor-row';
};

export const getVendorOrderLabel = (column) => column?.value || column?.orderLabel || '';

export const isVendorColumnSortable = (column) => {
  const orderLabel = getVendorOrderLabel(column);
  if (!orderLabel) return false;
  if (column?.sortable === false) return false;
  return VENDOR_SORTABLE_COLUMN_VALUES.includes(orderLabel);
};

export const normalizeVendorOrderBy = (orderBy) => {
  if (!orderBy || orderBy === 'alphabetical') return 'name';
  return orderBy;
};

export const getVendorOrderState = (filters) => {
  const [rawOrderBy, rawOrderDir] = Array.isArray(filters?.order) ? filters.order : DEFAULT_VENDOR_ORDER;
  return {
    orderBy: normalizeVendorOrderBy(rawOrderBy),
    orderDir: rawOrderDir === 'desc' ? 'desc' : 'asc',
  };
};

export const createFiltersWithVendorOrder = (filters = {}, order = DEFAULT_VENDOR_ORDER) => {
  const [orderBy, orderDir] = Array.isArray(order) ? order : DEFAULT_VENDOR_ORDER;
  const pagination = filters.pagination ? { ...filters.pagination, page: 1 } : { page: 1 };

  return {
    ...filters,
    order: [orderBy, orderDir === 'desc' ? 'desc' : 'asc'],
    pagination,
  };
};

export const getVendorPinnedLeftOffset = (visibleColumns, columnValue) => {
  const pinnedVisible = visibleColumns.filter((column) => VENDOR_PINNED_LEFT_COLUMN_VALUES.includes(column.value));
  const columnIndex = pinnedVisible.findIndex((column) => column.value === columnValue);

  if (columnIndex === -1) {
    return null;
  }

  return pinnedVisible.slice(0, columnIndex).reduce((offset) => offset + getVendorColumnWidth(), 0);
};

export const isVendorPinnedLeftColumn = (columnValue) => VENDOR_PINNED_LEFT_COLUMN_VALUES.includes(columnValue);

export const isLastVendorPinnedLeftColumn = (visibleColumns, columnValue) => {
  const pinnedVisible = visibleColumns.filter((column) => VENDOR_PINNED_LEFT_COLUMN_VALUES.includes(column.value));

  return pinnedVisible[pinnedVisible.length - 1]?.value === columnValue;
};
